import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {SocialService} from "../../providers/social-service";

@Component({
  selector: 'page-twitter-settings-followings',
  templateUrl: 'twitter-settings-followings.html',
})
export class TwitterSettingsFollowings {
  public followings = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private socialService: SocialService
  ) {}

  ionViewDidLoad() {
    this.socialService.getFollowings()
      .subscribe((data: any) => {
        this.followings = [];
        for (const element of data) {
          if (element) {
            this.followings.push({
              userId: element.userId,
              name: element.name,
              screenName: element.screenName,
              enabled: element.enabled,
              photoUrl: element.photoUrl,
              emailEnabled: element.emailEnabled,
              alarmEnabled: element.alarmEnabled,
            });
          }
        }
        //this.followings = data;
        //console.log(data);
        //console.log(this.followings);
      }, (err) => {
        console.error(err);
      });
  }

  public updateFollowings(f) {
    this.socialService.updateFollowings({
      id: f.userId,
      enabled: f.enabled,
      emailEnabled: f.emailEnabled,
      alarmEnabled: f.alarmEnabled
    })
      .subscribe((data) => {
        //console.log(data);
      }, (err) => {
        console.error(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/twitter-settings-followings/twitter-settings-followings.ts